<div class="frame-in">
  <div class="items north-america-2-frame">
    <svg class="road north-america-2">
      <style type="text/css">
      .a{filter:url(#f1);fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5;stroke-dasharray:15,15}.b{display:none;filter:url(#f2);fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5;stroke-dasharray:15,15}            </style>
      <defs>
        <filter x="-50%" y="-50%" width="200%" height="200%" id="f1" ><feDropShadow dx="-3.464101615137755" dy="1.9999999999999998" stdDeviation="0" flood-color="#0c3265" flood-opacity=".7"/></filter>
        <filter x="-50%" y="-50%" width="200%" height="200%" id="f2" ><feDropShadow dx="-3.464101615137755" dy="1.9999999999999998" stdDeviation="0" flood-color="#0c3265" flood-opacity=".7"/></filter>
      </defs>
      <g filter="url(#Filter_0)">
        <path class="a" d="m176 426c11.6 2.6 65.3 13.7 78 17 97.1 25.1 50.7-73.6 114-82 100.1-13.2 66.4 65.5 203 36 117.3-25.3 118.4-244.6 99-309-20.6-68.3-99.9-79.3-163-54-63.1 25.3-127.1 49.1-211-8-83.9-57.1-92.6 32.2-127 41-28 7.2-46.8 37.2-97 35-50.2-2.2-56.7 47.5-83 46"/><use  href="#img2" x="-6" y="5"/>
      </g>

      <g filter="url(#Filter_2)">
        <path class="b" d="m-66 449c0 0 43.6-54.8 208.1-30.7"/>
      </g>
    </svg>
    <div class="country north-america-2"></div>
    <div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 11, 'active': quizLevel === 11 && tick2Quiz}"></div>

    @for (zone of zones; track zone) {
      <div>
        <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
      </div>
    }

    @for (zone of zones; track zone; let i = $index) {
      <div
        class="poi {{zone.class}}"
        [ngClass]="{active: zone.active, 'lock': zone.locked}"
        (mouseenter)="mouseEnter(zone)"
        (mouseleave)="mouseLeave(zone)"
        (click)="selectZone(zone)">
        <span>{{ zone.locked ? '' : zone.number}}</span>
      </div>
    }
  </div>
</div>

<img class="frame-title" src="assets/images/zones/north-america-2/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('5-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('5-1')) {
        <a class="menu-item" [routerLink]="[ '/game/north-america-1' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('5-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('5-2')) {
        <a class="menu-item" [routerLink]="[ '/game/north-america-2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('5-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('5-3')) {
        <a class="menu-item" [routerLink]="[ '/game/north-america-3' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/north-america-2/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
